export default __webpack_public_path__ + "static/media/Rectangle_84.a89ce2f9.png";